<div class="phone__container">
  <div class="form-group country__code">
    <input
      #searchField
      type="text"
      inputmode="tel"
      name="search"
      id="search"
      autocomplete="off"
      placeholder="&nbsp;"
      required
      class=""
      [ngClass]="{ error: !phoneValid }"
      [(ngModel)]="selectedCode"
      (keyup)="searchCodes($event)"
      (click)="showHideCountryCodePicker(); clearSearchField()"
    />
    <label for="search">
      {{ 'checkin-form.country-code' | translate }}
    </label>
    <div
      #dropDown
      class="country__dropdown scroll"
      id="dropDown"
      [ngClass]="{ 'phone-field__dropdown--opened': showCountryCodePicker }"
    >
      <a
        *ngFor="let countryCode of filteredPhoneCodes; trackBy: trackByFilteredPhoneCodes"
        class="country__dropdown--code"
        [class]="'country-flag country-flag-' + countryCode[0]"
        (click)="selectCode(countryCode)"
      >
        {{ countryCode[1] }}
      </a>
    </div>
  </div>
  <div class="form-group">
    <input
      data-hj-suppress
      type="text"
      placeholder="&nbsp;"
      required
      inputmode="tel"
      appInputNumbers
      [class]="'phone-field__input' + (cssModifier ? ' phone-field__input--' + cssModifier : '')"
      id="{{ id }}"
      tabindex="{{ tabindex }}"
      [ngClass]="{ error: !phoneValid }"
      [(ngModel)]="phoneNumber"
      (paste)="onPaste($event)"
      (ngModelChange)="onChange()"
      (keyup)="enterPhone()"
    />
    <label>
      {{ 'profile.phone-number' | translate }}
    </label>
  </div>
</div>
